import { render, staticRenderFns } from "./CardVorm.vue?vue&type=template&id=7bd3d8c7"
import script from "./CardVorm.vue?vue&type=script&lang=js"
export * from "./CardVorm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports